import SelectContianer from '@components/officialWebStore/SelectContianer';
export default {
  components: { SelectContianer },
  props: ['showChildSelector'],
  data() {
    return {
      showChildSelect: false
    };
  },
  computed: {
    letter() {
      return this.$store.state.letter;
    }
  },
  watch: {
    showChildSelector(newVal) {
      this.showChildSelect = newVal;
    }
  },
  methods: {
    close() {
      this.$emit('closeSelecter');
    }
  }
};
